export default "__VITE_ASSET__Cn76g44a__"